import { createClient } from "@supabase/supabase-js";

// ─── SUPABASE CLIENT ──────────────────────────────────────────────────────────
// The client is created the first time something uses it. The public demo (/demo) never uses it, so a visitor
// on the demo page makes no database calls at all, not even to refresh an old sign-in.
let supabaseClient = null;
const supabase = new Proxy({}, {
  get(_target, prop) {
    if (!supabaseClient) {
      supabaseClient = createClient(
        process.env.REACT_APP_SUPABASE_URL,
        process.env.REACT_APP_SUPABASE_ANON_KEY
      );
    }
    const value = supabaseClient[prop];
    return typeof value === "function" ? value.bind(supabaseClient) : value;
  },
});

// The signed-in user's access token, for server routes that check who is calling.
async function getAccessToken() {
  const { data } = await supabase.auth.getSession();
  return data?.session?.access_token || null;
}

export { supabase, getAccessToken };
